import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { renderDndElementStyle } from '../../ui-item-maker/element-config-grouping/element-config-grouping.component';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { Subject } from 'rxjs';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
//import { IElementPos } from 'src/app/ui-item-maker/element-config-dnd/element-config-dnd.component';
import { IContentElementDndSub, IContentElementDndDraggable, IElementPos } from '../element-render-dnd/model';
import { IEntryStateGroup } from '../element-render-grouping/model';
import { ScoringTypes, QuestionState, getElementWeight } from '../models';
import { LangService } from '../../core/lang.service';

const SCORING_TYPE = ScoringTypes.AUTO;
@Component({
  selector: 'element-render-matching',
  templateUrl: './element-render-matching.component.html',
  styleUrls: ['./element-render-matching.component.scss']
})
export class ElementRenderMatchingComponent implements OnInit {
  private static nextInstanceId = 0;

  @Input() element;
  @Input() isLocked: boolean;
  @Input() questionState: QuestionState;
  @Input() changeCounter: number;
  @Input() questionPubSub?: QuestionPubSub;

  draggables: IElementPos[] = [];
  targets: IElementPos[] = [];
  @ViewChild('mainDraggables') mainDraggables;
  readonly instanceId = `element-matching-${ElementRenderMatchingComponent.nextInstanceId++}`;
  selectedItem: {item:IElementPos, source:IElementPos[]} = null;
  liveMessage = '';
  
  constructor(private lang:LangService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isLocked && this.isLocked) this.selectedItem = null;
    if (changes.changeCounter){
      this.selectedItem = null;
      this.updateDisplayEls();
    }
  }
  

  updateDisplayEls() {

    this.draggables = [];
    this.targets = [];
    this.element.targets.forEach(element => this.addElementToList(element, this.targets, true));
    this.element.draggables.forEach(element => this.addElementToList(element, this.draggables));
  }

  addElementToList(element: IContentElementDndSub, elementsToPosition: IElementPos[], isTarget: boolean= false) {
    let hasElement  = false;
    if ((<IContentElementDndDraggable> element).element) {
      hasElement = true;
    }
    elementsToPosition.push({
      ref: element,
      originalX: element.x,
      originalY: element.y,
      isTarget,
      style: renderDndElementStyle(element, hasElement, isTarget && this.element.customTargetDim, this.element.defaultTargetStyle),
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (this.isLocked) return;
    if (event.container.id === this.mainDraggables.nativeElement.id) {
      this.dragAction(event);
    } else if (!event.container.data.length) {
      this.dragAction(event);
    }
  }

  dragAction(event: CdkDragDrop<string[]>) {
    if (this.isLocked) return;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
    this.selectedItem = null;
    this.updateState();
  }

  getInstructionsId(){
    return `${this.instanceId}-instructions`;
  }

  getTargetLabelId(index:number){
    return `${this.instanceId}-target-${index}`;
  }

  getSourceLabel(){
    return this.lang.tra('voice_grouping_terms');
  }

  getSelectionInstructions(){
    return this.lang.tra('sr_matching_instructions');
  }

  isSelected(item:IElementPos){
    return !!this.selectedItem && this.selectedItem.item === item;
  }

  selectItem(item:IElementPos, source:IElementPos[]){
    if (this.isLocked){
      return;
    }
    if (this.isSelected(item)){
      this.selectedItem = null;
      this.liveMessage = this.lang.tra('sr_matching_selection_cleared');
      return;
    }
    this.selectedItem = { item, source };
    this.liveMessage = this.lang.tra('sr_matching_item_selected');
  }

  handleItemKeydown(event:KeyboardEvent, item:IElementPos, source:IElementPos[]){
    if (event.key !== 'Enter'){
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.selectItem(item, source);
  }

  placeSelected(destination:IElementPos[], isHomeDestination:boolean){
    if (this.isLocked || !this.selectedItem){
      return;
    }

    const {item, source} = this.selectedItem;
    if (source === destination){
      this.selectedItem = null;
      this.liveMessage = this.lang.tra(isHomeDestination ? 'sr_matching_returned' : 'sr_matching_item_moved');
      return;
    }
    if (!isHomeDestination && destination.length){
      this.liveMessage = this.lang.tra('sr_matching_target_full');
      return;
    }

    transferArrayItem(source, destination, source.indexOf(item), destination.length);
    this.selectedItem = null;
    this.updateState();
    this.liveMessage = this.lang.tra(isHomeDestination ? 'sr_matching_returned' : 'sr_matching_item_moved');
  }

  private updateState(){
    this.element.draggables = this.draggables.map(drag => drag.ref);
    const isStarted = !!this.element.targets.find(target => target.groups.length);
    const isFilled = !!this.element.targets.find(target => target.groups.length);
    const isCorrect = !!this.element.targets.find(target => target.groups.length);
    const weight = getElementWeight(this.element);
    let entryState: IEntryStateGroup = {
      type: 'matching',
      isCorrect,
      isStarted,
      isFilled,
      score: isCorrect ? weight : 0,
      weight,
      scoring_type: SCORING_TYPE,
      draggables: this.element.draggables,
      targets: this.element.targets
    };
    this.questionState[this.element.entryId] = entryState;
  }

}
